module.exports = __webpack_public_path__ + "ef74e6e1143e27805a9cc5abd67ed296.png";